import React from 'react';
import { Medal, Plus, X } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import AddAwardForm from './AddAwardForm';

const AwardsSection = ({ awards, awardBodies, showAddAward, onLoadAwardBodies, onAddAward, onRemoveAward, onCancelAdd }) => {
  return (
    <div className="card-elevated card-padding" data-testid="awards-section">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-xl font-semibold flex items-center gap-2">
          <Medal weight="duotone" className="w-5 h-5 text-[#C4A35A]" />
          Awards & Accolades
        </h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={onLoadAwardBodies}
          className="text-[#A94438] hover:text-[#A94438]/80"
          data-testid="add-award-btn"
        >
          <Plus weight="bold" className="w-4 h-4 mr-1" />
          Add
        </Button>
      </div>

      {awards && awards.length > 0 ? (
        <div className="space-y-2" data-testid="awards-list">
          {awards.map((award) => (
            <div key={award.id} className="flex items-center justify-between py-2 px-3 bg-[#F9F8F5] rounded-lg group">
              <div className="flex items-center gap-3">
                <Medal weight="fill" className="w-5 h-5 text-[#C4A35A]" />
                <div>
                  <span className="text-sm font-medium text-[#1A1918]">{award.award_name}</span>
                  <span className="text-sm text-[#7A7873] ml-2">{award.level}</span>
                </div>
                <span className="text-xs text-[#9A9590] bg-white px-2 py-0.5 rounded-full">{award.year}</span>
              </div>
              <button
                onClick={() => onRemoveAward(award.id)}
                className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-red-50 rounded"
                data-testid={`remove-award-${award.id}`}
              >
                <X weight="bold" className="w-4 h-4 text-red-400" />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-[#9A9590] text-center py-4">No awards yet. Add Eat Out, Michelin, or other accolades.</p>
      )}

      {showAddAward && awardBodies && (
        <AddAwardForm
          awardBodies={awardBodies}
          onAdd={onAddAward}
          onCancel={onCancelAdd}
        />
      )}
    </div>
  );
};

export default AwardsSection;
